import { render } from "./OrderProductDetails.vue?vue&type=template&id=a47b5608"
import script from "./OrderProductDetails.vue?vue&type=script&lang=js"
export * from "./OrderProductDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__